import request from '@/utils/request'

// 卡商账户列表接口
export const getCardAccountList = (params: any) =>
  request({
    url: 'manage/card-account',
    method: 'get',
    params
  })

// 创建卡商账户
export const addCardAccount = (data: any) =>
  request({
    url: 'manage/card-account',
    method: 'post',
    data
  })

// 获取卡商产品账户列表
export const getCardAccountProductList = (params: any) =>
  request({
    url: `manage/card-product-account/${params.id}`,
    method: 'get',
    params
  })

// 创建卡商产品账户
export const addCardProductAccount = (data: any) =>
  request({
    url: `manage/card-account/${data.id}`,
    method: 'patch',
    data
  })

// 获取卡商账户余额列表
export const getCardAccountBalanceList = (params: any) =>
  request({
    url: `manage/card-account-bill/${params.id}`,
    method: 'get',
    params
  })

// 删除卡商账户
export const deleteCardAccount = (data: any) =>
  request({
    url: `manage/card-account/${data.id}`,
    method: 'delete'
  })

// 获取绑定产品账户列表
export const getCardAccount = (params: any) => {
  return request({
    url: '/manage/card-all-product-account',
    method: 'get',
    params
  })
}
